import axios from 'axios'
import _ from 'lodash'
import store from '../store'

export default () => {

  const apiDomain = _.get(store.state, 'props.apiDomain', '') 

  return {
    /*
    * Get events from API using custom query params
    */
    async searchWithParams(params) {
      if (params) {
        params.region = _.get(store.state, 'props.region') 
          ? store.state.props.region.toUpperCase()
          : ''
      }                    
        
      return await axios.get(apiDomain + '/v1/events/search', { params: params });
    },

    /*
    * Get event details by Id
    */
    async getEventById(eventId) {
      return await this.searchWithParams({
        eventcampaignid: eventId
      })
    }
  }
}